// src/services/catalogo.js
import axios from 'axios'
const http = axios

let _tipos = []
let _items = []
let _tipoById = Object.create(null)
let _itemsByCodigo = Object.create(null)

let _itemById = Object.create(null)
let _byCodeId = Object.create(null)

let _loading = null

const toOption = (x) => ({ oid: x.oid, nombre: x.nombre, orden: x.orden })

export async function loadAll () {
  if (_loading) return _loading
  if (_tipos.length && _items.length) return { tipos: _tipos, items: _itemsByCodigo }

  _loading = (async () => {
    const [{ data: tipos }, { data: items }] = await Promise.all([
      http.get('api/CatalogoTipoes/Listar'),
      http.get('api/CatalogoItems/Listar'),
    ])

    _tipos = Array.isArray(tipos) ? tipos : []
    _items = Array.isArray(items) ? items : []

    _tipoById = Object.create(null)
    for (const t of _tipos) _tipoById[t.oid] = t

    _itemsByCodigo = Object.create(null)
    _itemById = Object.create(null)
    _byCodeId = Object.create(null)

    for (const it of _items) {
      _itemById[it.oid] = it

      const tipo = _tipoById[it.oid_tipo]
      if (!tipo) continue
      const code = tipo.codigo

      if (!_itemsByCodigo[code]) _itemsByCodigo[code] = []
      _itemsByCodigo[code].push(it)

      if (!_byCodeId[code]) _byCodeId[code] = Object.create(null)
      _byCodeId[code][it.oid] = it
    }

    _loading = null
    return { tipos: _tipos, items: _itemsByCodigo }
  })()

  return _loading
}

export async function refresh () {
  _tipos = []; _items = []
  _tipoById = Object.create(null)
  _itemsByCodigo = Object.create(null)
  _itemById = Object.create(null)
  _byCodeId = Object.create(null)
  _loading = null
  return loadAll()
}

export function getOptionsByCodigo (codigo, { onlyActive = true } = {}) {
  const arr = _itemsByCodigo[codigo] || []
  const filtered = onlyActive ? arr.filter(i => i.activo) : arr
  return filtered.map(toOption)
}

// 👇 helpers que ahora sí funcionan
export function getItem (codigo, id) {
  return _byCodeId[codigo]?.[Number(id)] || null
}
export function getName (codigo, id, fallback = '') {
  return getItem(codigo, id)?.nombre ?? fallback
}
export function getNameById (oid) {
  const it = _itemById[Number(oid)]
  return it ? it.nombre : undefined
}

// PAIS
let _pais = [];
let _depto = [];
let _ciudad = [];

export async function setDatos() {
    const [p, d, c] = await Promise.all([
      axios.get('api/PersonaInfoGenerals/ListarUPais'),
      axios.get('api/PersonaInfoGenerals/ListarUDepto'),
      axios.get('api/PersonaInfoGenerals/ListarUCiudad'),
    ]);

    _pais   = Array.isArray(p.data) ? p.data : [];
    _depto  = Array.isArray(d.data) ? d.data : [];
    _ciudad = Array.isArray(c.data) ? c.data : [];
    return true;
}

// Getters de listas completas
export const getPaises   = () => _pais.slice();
export const getDeptos   = () => _depto.slice();
export const getCiudades = () => _ciudad.slice();

// Getters por relación (útiles para selects dependientes)
export const getDeptosPorPais = (oidPais) =>
  _depto.filter(x => Number(x.oid_pais) === Number(oidPais));

export const getCiudadesPorDepto = (oidDepto) =>
  _ciudad.filter(x => Number(x.oid_depto) === Number(oidDepto));

export function getPaisN(oid) {
    const id = Number(oid); // por si llega como string
    const item = _pais.find(e => Number(e.oid) === id);
    return item ? item.nombre : 'Desconocido';
}
export function getDeptoN(oid) {
    const id = Number(oid); // por si llega como string
    const item = _depto.find(e => Number(e.oid) === id);
    return item ? item.nombre : 'Desconocido';
}
export function getCiudadN(oid) {
    const id = Number(oid); // por si llega como string
    const item = _ciudad.find(e => Number(e.oid) === id);
    return item ? item.nombre : 'Desconocido';
}

// AREAS
let _areas = [];

export async function setAreas() {
    const { data } = await axios.get('api/PersonaInfoGenerals/ListarAreas');
    _areas = Array.isArray(data) ? data : [];
    return _areas;
}

export function getAreasN(oid) {
    const id = Number(oid); // por si llega como string
    const item = _areas.find(e => Number(e.th_area_id) === id);
    return item ? item.th_areas_nombre : 'Desconocido';
}